import React, { FunctionComponent } from 'react';

import { Skeleton } from '@yandex-360/orb-components/dist/components/Skeleton';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { selectFullHistoryArtifactsEnabled } from '../../../../../../shared/features/flags/selectors';
import { useIsOneColLayout } from '../../../../hooks';
import styles from './styles.css';

export const ArtifactsLoadingSkeleton: FunctionComponent = () => {
    const isOneColLayout = useIsOneColLayout();
    const historyFullArtifacts = useSelector(selectFullHistoryArtifactsEnabled);
    return (
        <div className={cn(styles.artifactsLoadingSkeleton, { [styles.oneColLayout]: isOneColLayout })}>
            <div className={styles.header}>
                <Skeleton height="var(--orb-size-24-m)" width="100%" />
            </div>
            {historyFullArtifacts && (
                <div className={styles.body}>
                    <Skeleton height="var(--orb-size-24-m)" width="100%" />
                    <Skeleton height="var(--conferences-history-drawer-artifacts-skeleton-height)" width="100%" />
                    <Skeleton height="var(--conferences-history-drawer-artifacts-skeleton-height)" width="100%" />
                    <Skeleton height="var(--conferences-history-drawer-artifacts-skeleton-height)" width="100%" />
                    <Skeleton height="var(--orb-size-24-m)" width="100%" />
                </div>
            )}
        </div>
    );
};
